import { Fragment } from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import constants from '../Config/constants';
import { getIsEnabledReservation } from '../Helper/RemoteConfig';
import MyReservationDetails from '../Screens/MyReservationDetails';
import MyReservations from '../Screens/MyReservations';
import Reservation from '../Screens/Reservation';
import ReservationCheckout from '../Screens/ReservationCheckout';
import ReservationCheckoutAddOns from '../Screens/ReservationCheckoutAddOns';
import ReservationEventDetails from '../Screens/ReservationEventDetails';
import ReservationStoreDetails from '../Screens/ReservationStoreDetails';
import Search from '../Screens/Search';

import routeList, { ReservationNavigatorProps } from './list';

const Stack = createStackNavigator<ReservationNavigatorProps>();

export const getReservationPublicRoutes = () => {
  const isEnabled = getIsEnabledReservation();
  if (!isEnabled) return null;
  return (
    <Fragment>
      <Stack.Screen
        name={routeList.RES_STORE_DETAILS_BOOK}
        component={ReservationStoreDetails}
        initialParams={{ exclusiveBooking: '1' }} // string 1, for consistency on web url parameter and mobile
      />
      <Stack.Screen
        name={routeList.RES_EVENT_DETAILS}
        component={ReservationEventDetails}
      />
      <Stack.Screen
        name={routeList.RES_EVENT_DETAILS_PREVIEW}
        component={ReservationEventDetails}
      />
      <Stack.Screen
        name={routeList.RES_CHECKOUT_ADDONS}
        component={ReservationCheckoutAddOns}
      />
      <Stack.Screen
        name={routeList.RES_CHECKOUT}
        component={ReservationCheckout}
      />
      <Stack.Screen
        name={routeList.MY_RESERVATION_DETAILS}
        component={MyReservationDetails}
      />
    </Fragment>
  );
};

const ReservationNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{ headerShown: false }}
      initialRouteName={routeList.RESERVATION}
    >
      <Stack.Screen name={routeList.RESERVATION} component={Reservation} />
      {!constants.isWeb && (
        <Stack.Screen name={routeList.SEARCH} component={Search} />
      )}
      <Stack.Screen
        name={routeList.MY_RESERVATIONS}
        component={MyReservations}
      />
      <Stack.Screen
        name={routeList.RES_STORE_DETAILS}
        component={ReservationStoreDetails}
      />
      {getReservationPublicRoutes()}
    </Stack.Navigator>
  );
};

export default ReservationNavigator;
